import React from 'react';
import { Bar } from 'react-chartjs-2';

const COLORS = ['#3B82F6', '#10B981', '#F59E0B', '#EF4444', '#8B5CF6', '#EC4899', '#06B6D4', '#84CC16'];

const StockUsage = ({ data }) => {
    if (!data || data.length === 0) return null;

    const maxShow = Math.min(data.length, 8);
    const sliced = data.slice(0, maxShow);
    const labels = sliced.map(d => d.item_name?.split(' ').slice(0, 3).join(' ') || d.item_code || 'Unknown');
    const values = sliced.map(d => d.total_used);
    const colors = labels.map((_, i) => COLORS[i % COLORS.length]);

    const chartData = {
        labels,
        datasets: [{
            label: 'Quantity Used',
            data: values,
            backgroundColor: colors,
            borderRadius: 4,
        }],
    };

    const options = {
        responsive: true,
        indexAxis: 'y',
        plugins: {
            legend: { display: false },
        },
        scales: {
            x: { title: { display: true, text: 'Quantity Used' } },
        },
    };

    return (
        <div className="card shadow-sm h-100">
            <div className="card-body">
                <h6 className="card-title mb-3">Top Stock Usage</h6>
                <Bar data={chartData} options={options} />
            </div>
        </div>
    );
};

const LowStockAlerts = ({ data, purchaseSummary }) => {
    if (!data || data.length === 0) return null;

    return (
        <div className="card shadow-sm h-100">
            <div className="card-body">
                <h6 className="card-title mb-3 text-danger">Low Stock Alerts</h6>
                <div className="table-responsive" style={{ maxHeight: '250px' }}>
                    <table className="table table-sm table-hover mb-0">
                        <thead className="table-light">
                            <tr>
                                <th>Item</th>
                                <th className="text-end">On Hand</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.slice(0, 10).map((item, i) => (
                                <tr key={item.item_id || i}>
                                    <td style={{ fontSize: '0.8rem' }}>
                                        {item.item_name || item.item_code || 'Unknown'}
                                    </td>
                                    <td className="text-end text-danger fw-bold" style={{ fontSize: '0.8rem' }}>
                                        {item.on_hand?.toLocaleString()}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                {purchaseSummary && (
                    <div className="mt-2 pt-2 border-top">
                        <small className="text-muted">
                            Purchases: <strong>{purchaseSummary.total_purchases?.toLocaleString(undefined, { minimumFractionDigits: 3 })} KWD</strong>
                            {' '}({purchaseSummary.invoice_count} invoices)
                        </small>
                    </div>
                )}
            </div>
        </div>
    );
};

const InventoryCharts = ({ stockUsage, lowStockAlerts, purchaseSummary }) => {
    if (!stockUsage && !lowStockAlerts && !purchaseSummary) return null;

    return (
        <div className="mb-4">
            <h5 className="mb-3 border-bottom pb-2">Inventory & Stock</h5>
            <div className="row g-3">
                <div className="col-md-6">
                    <StockUsage data={stockUsage} />
                </div>
                <div className="col-md-6">
                    <LowStockAlerts data={lowStockAlerts} purchaseSummary={purchaseSummary} />
                </div>
            </div>
        </div>
    );
};

export default InventoryCharts;
